import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomCalendarIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 36 38" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path d="M0 36V8H36V36C36 37.1 35.1 38 34 38H2C0.9 38 0 37.1 0 36Z" fill={`url(#${uuid}paint0_linear)`} />
      <path d="M36 4V10H0V4C0 2.9 0.9 2 2 2H34C35.1 2 36 2.9 36 4Z" fill={`url(#${uuid}paint1_linear)`} />
      <path
        d="M29.5 8.5C27.843 8.5 26.5 7.157 26.5 5.5V2H32.5V5.5C32.5 7.157 31.157 8.5 29.5 8.5Z"
        fill="black"
        opacity="0.05"
      />
      <path
        d="M29.5 7.75C28.257 7.75 27.25 6.743 27.25 5.5V2H31.75V5.5C31.75 6.743 30.743 7.75 29.5 7.75Z"
        fill="black"
        opacity="0.07"
      />
      <path
        d="M6.5 8.5C4.843 8.5 3.5 7.157 3.5 5.5V2H9.5V5.5C9.5 7.157 8.157 8.5 6.5 8.5Z"
        fill="black"
        opacity="0.05"
      />
      <path
        d="M6.5 7.75C5.257 7.75 4.25 6.743 4.25 5.5V2H8.75V5.5C8.75 6.743 7.743 7.75 6.5 7.75Z"
        fill="black"
        opacity="0.07"
      />
      <path
        d="M6.5 7C5.672 7 5 6.328 5 5.5V1.5C5 0.672 5.672 0 6.5 0C7.328 0 8 0.672 8 1.5V5.5C8 6.328 7.328 7 6.5 7Z"
        fill="#7D38D6"
      />
      <path
        d="M32 15.5V18.5C32 18.776 31.776 19 31.5 19H28.5C28.224 19 28 18.776 28 18.5V15.5C28 15.224 28.224 15 28.5 15H31.5C31.776 15 32 15.224 32 15.5ZM24 15.5V18.5C24 18.776 23.776 19 23.5 19H20.5C20.224 19 20 18.776 20 18.5V15.5C20 15.224 20.224 15 20.5 15H23.5C23.776 15 24 15.224 24 15.5ZM16 15.5V18.5C16 18.776 15.776 19 15.5 19H12.5C12.224 19 12 18.776 12 18.5V15.5C12 15.224 12.224 15 12.5 15H15.5C15.776 15 16 15.224 16 15.5Z"
        fill="white"
      />
      <path
        d="M32 22.5V25.5C32 25.776 31.776 26 31.5 26H28.5C28.224 26 28 25.776 28 25.5V22.5C28 22.224 28.224 22 28.5 22H31.5C31.776 22 32 22.224 32 22.5ZM24 22.5V25.5C24 25.776 23.776 26 23.5 26H20.5C20.224 26 20 25.776 20 25.5V22.5C20 22.224 20.224 22 20.5 22H23.5C23.776 22 24 22.224 24 22.5ZM16 22.5V25.5C16 25.776 15.776 26 15.5 26H12.5C12.224 26 12 25.776 12 25.5V22.5C12 22.224 12.224 22 12.5 22H15.5C15.776 22 16 22.224 16 22.5ZM8 22.5V25.5C8 25.776 7.776 26 7.5 26H4.5C4.224 26 4 25.776 4 25.5V22.5C4 22.224 4.224 22 4.5 22H7.5C7.776 22 8 22.224 8 22.5Z"
        fill="white"
      />
      <path
        d="M24 29.5V32.5C24 32.776 23.776 33 23.5 33H20.5C20.224 33 20 32.776 20 32.5V29.5C20 29.224 20.224 29 20.5 29H23.5C23.776 29 24 29.224 24 29.5ZM16 29.5V32.5C16 32.776 15.776 33 15.5 33H12.5C12.224 33 12 32.776 12 32.5V29.5C12 29.224 12.224 29 12.5 29H15.5C15.776 29 16 29.224 16 29.5ZM8 29.5V32.5C8 32.776 7.776 33 7.5 33H4.5C4.224 33 4 32.776 4 32.5V29.5C4 29.224 4.224 29 4.5 29H7.5C7.776 29 8 29.224 8 29.5Z"
        fill="white"
      />
      <path
        d="M29.5 7C28.672 7 28 6.328 28 5.5V1.5C28 0.672 28.672 0 29.5 0C30.328 0 31 0.672 31 1.5V5.5C31 6.328 30.328 7 29.5 7Z"
        fill="#7D38D6"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear`}
          x1="0.414001"
          x2="101.5"
          y1="9.662"
          y2="88.5"
        >
          <stop stopColor="#A37DD5" />
          <stop offset="1" stopColor="#047ED6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint1_linear`}
          x1="0.42"
          x2="59"
          y1="2.608"
          y2="14.5"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#0B59A2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
